import React from "react";
import Nav from "../components/layout/Nav";
import Footer from "../components/layout/Footer";
import { site } from "../data/content";

export default function Impressum() {
  return (
    <>
      <Nav />
      <main
        className="max-w-[70rem] mx-auto px-6 sm:px-8 lg:px-12 pt-40 pb-24 lg:pb-32"
        data-testid="impressum-page"
      >
        <p className="eyebrow">Rechtliches</p>
        <h1 className="mt-4 font-display font-medium text-5xl lg:text-7xl tracking-tighter leading-[1.02]">
          Impressum
        </h1>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-12 text-brand-primary leading-relaxed">
          <section>
            <h2 className="text-xl font-medium tracking-tight">
              Angaben gemäß § 5 TMG
            </h2>
            <address className="mt-4 not-italic text-brand-primary/85">
              <strong>Metalotsen</strong>
              <br />
              Inhaber: {site.owner}
              <br />
              {site.address.street}
              <br />
              {site.address.zip} {site.address.city}
              <br />
              {site.address.country}
            </address>
          </section>

          <section>
            <h2 className="text-xl font-medium tracking-tight">Kontakt</h2>
            <p className="mt-4 text-brand-primary/85">
              Telefon: {site.phone}
              <br />
              E-Mail:{" "}
              <a
                href={`mailto:${site.email}`}
                className="text-brand-accent hover:text-brand-accentHover"
              >
                {site.email}
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-medium tracking-tight">
              Umsatzsteuer-ID
            </h2>
            <p className="mt-4 text-brand-primary/85">
              Umsatzsteuer-Identifikationsnummer gemäß § 27a
              Umsatzsteuergesetz: <em>wird auf Anfrage mitgeteilt</em>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-medium tracking-tight">
              Redaktionell Verantwortlicher
            </h2>
            <p className="mt-4 text-brand-primary/85">
              {site.owner}
              <br />
              Anschrift wie oben
            </p>
          </section>

          <section className="lg:col-span-2">
            <h2 className="text-xl font-medium tracking-tight">
              EU-Streitschlichtung
            </h2>
            <p className="mt-4 text-brand-primary/85 max-w-3xl">
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noreferrer"
                className="text-brand-accent hover:underline"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              . Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind
              nicht bereit oder verpflichtet, an
              Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section className="lg:col-span-2">
            <h2 className="text-xl font-medium tracking-tight">Haftung</h2>
            <p className="mt-4 text-brand-primary/85 max-w-3xl">
              Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine
              Haftung für die Inhalte externer Links. Für den Inhalt der
              verlinkten Seiten sind ausschließlich deren Betreiber
              verantwortlich.
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}
